import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { trpc } from '~frontend/router'

export const Route = createFileRoute('/_LoggedIn/attendance/session/previous')({
    component: RouteComponent,
})

function RouteComponent() {
    const { data: sessions } = useQuery(trpc.session.getPreviousSessions.queryOptions({
        page: 1,
        limit: 10,
    }))



    return (JSON.stringify(sessions, null, 2))
}
